// extracted by mini-css-extract-plugin
export default {"card":"Card-card-aoesq","underlay":"Card-underlay-bObAW","overlay":"Card-overlay-WuJz0"};